import { roundDigits, isNumNaN } from "../../utils/funcs/common";
import { EmployeeSalaryCalc } from "../../interfaces/app_types";
import { getPastMonthYear } from "../../utils/funcs/days";
import { getWorkingDays } from "../../utils/funcs/time";
import { useRecoilValue } from "recoil";
import { holidayState } from "../../utils/atoms/atoms";

const SalaryDisplay = ({
  rate,
  last_increment,
  sundays,
  travel,
  extra,
  loan_cut,
  working_hrs,
  present,
  eleven_hrs,
  add_hours,
  one_punch,
  add_cash,
}: EmployeeSalaryCalc) => {
  const getSalary = () => {
    const holidayCount = useRecoilValue(holidayState);
    const lunchTime = 0.5;
    const actualHours =
      working_hrs - lunchTime * (present - sundays - one_punch);
    const { month, year } = getPastMonthYear();
    let incentive = 0;
    const totalWorkingDays = getWorkingDays(month, year);
    if (present >= totalWorkingDays - holidayCount) {
      incentive = rate * 1;
    }
    const nasta = 20 * eleven_hrs;
    const base = (rate / 8) * (actualHours + add_hours);
    const holiday = holidayCount * rate;
    const sundayPrice = sundays * 40;
    const calculatedExtra =
      present < 20 ? roundDigits((extra / 26) * present, 3) : extra;
    const calculatedTravel =
      present < 20 ? roundDigits((travel / 26) * present, 3) : travel;

    const total =
      nasta +
      calculatedExtra +
      calculatedTravel +
      base +
      add_cash +
      holiday +
      sundayPrice +
      incentive;
    const totalWithCut = total - loan_cut;
    return {
      base,
      holiday,
      nasta,
      total,
      incentive,
      sundayPrice,
      totalWithCut,
      loan_cut,
      calculatedExtra,
      calculatedTravel,
    };
  };

  const {
    base,
    holiday,
    nasta,
    incentive,
    totalWithCut,
    sundayPrice,
    calculatedExtra,
    calculatedTravel,
  } = getSalary();

  const salaryCap = 18500;
  let first = 0;
  let second = 0;
  if (totalWithCut > salaryCap) {
    first = salaryCap;
    second = isNumNaN(roundDigits(totalWithCut - salaryCap, 2));
  } else {
    first = isNumNaN(roundDigits(totalWithCut, 2));
  }
  // let first = salaryCap  - isNumNaN(roundDigits(totalWithCut, 2))

  return (
    <div className="f-between heading-4">
      <div className="p-1">
        Salary:
        <span className="text-success">
          {" "}
          {isNumNaN(roundDigits(totalWithCut, 2))}
        </span>
        <div className="h-4">
          1: {first}, 2: {second}
        </div>
      </div>
      <div className="d-flex heading-5 flex-wrap">
        <div className="p-1">
          Base:{" "}
          <span className="text-success">{isNumNaN(roundDigits(base, 2))}</span>
        </div>
        <div className="p-1">
          Holiday: <span className="text-success">{isNumNaN(holiday)}</span>
        </div>
        <div className="p-1">
          Nasta: <span className="text-success">{isNumNaN(nasta)}</span>
        </div>
        <div className="p-1">
          Extra:{" "}
          <span className="text-success">{isNumNaN(calculatedExtra)}</span>
        </div>
        <div className="p-1">
          Travel:{" "}
          <span className="text-success">{isNumNaN(calculatedTravel)}</span>
        </div>

        <div className="p-1">
          Sunday: <span className="text-success">{isNumNaN(sundayPrice)}</span>
        </div>
        <div className="p-1">
          Incentive: <span className="text-success">{isNumNaN(incentive)}</span>
        </div>
        <div className="p-1">
          Loan Cut:{"  "}
          <span className="text-danger">{isNumNaN(loan_cut)}</span>
        </div>
      </div>
    </div>
  );
};

export default SalaryDisplay;
